import { frontendURL } from 'dashboard/helper/URLHelper.js';

import KraftchatAIPage from './pages/KraftchatAIPage.vue';

const meta = {
  permissions: ['administrator'],
};

const kraftchatAIRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/kraftchat-ai'),
      redirect: to => {
        return { name: 'kraftchat_ai_overview', params: to.params };
      },
      children: [
        {
          path: 'overview',
          name: 'kraftchat_ai_overview',
          meta,
          component: KraftchatAIPage,
        },
        {
          path: 'settings',
          name: 'kraftchat_ai_settings',
          meta,
          component: KraftchatAIPage,
        },
        {
          path: 'knowledge',
          name: 'kraftchat_ai_knowledge',
          meta,
          component: KraftchatAIPage,
        },
        {
          path: 'rules',
          name: 'kraftchat_ai_rules',
          meta,
          component: KraftchatAIPage,
        },
        {
          path: 'playground',
          name: 'kraftchat_ai_playground',
          meta,
          component: KraftchatAIPage,
        },
      ],
    },
  ],
};

export default kraftchatAIRoutes;
